import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJasmineComponent } from './simple-icons-jasmine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJasmineComponent ],
    exports:      [ SimpleIconsJasmineComponent ],
    bootstrap:    []
})
export class SimpleIconsJasmineModule {}
